import { cx } from "@emotion/css";

import EntranceSpotExampleImg from "@/assets/entrance-example.png";

/**
 * Entrance photo guidance (new layout: one OK image, NG items as text only).
 *
 * Used by `LiteSpot`, `PATMOSpot`, and dearis `EntranceSpot`. Gate / elevator
 * flows still use `EntrancePhotoExamples` where applicable.
 */
export const EntrancePhotoGuide = ({ className }: { className?: string }) => {
  return (
    <section
      className={cx(
        "m-0 text-[14px] font-normal leading-6 tracking-normal text-neutral-800",
        className
      )}
    >
      <h2 className="mb-4 mt-0 text-center text-[16px] font-semibold leading-6 tracking-normal text-neutral-800">
        入口の写真について
      </h2>
      <p className="mb-1 text-[#FF3141]">入口の写真を撮影してください。</p>
      <p>手ブレや人の映り込みに注意してください。</p>

      <div className="mt-[20px]">
        <div className="flex items-start gap-1">
          <GuideBar />
          <p className="min-w-0 flex-1">OK例：正面から撮影し、どのドアかがわかりやすい</p>
        </div>
        <img
          alt=""
          className="mt-[10px] block h-auto w-full max-w-full rounded-none"
          src={EntranceSpotExampleImg}
        />
      </div>

      <ul className="m-0 mb-[16px] mt-[20px] flex list-none flex-col gap-[20px] p-0">
        <li className="flex items-start gap-1">
          <GuideBar />
          <span className="min-w-0 flex-1">NG例：集合玄関機の写真になっている。</span>
        </li>
        <li className="flex items-start gap-1">
          <GuideBar />
          <span className="min-w-0 flex-1">NG例：脚立や工具が映り込んでいる、ドアが開いている</span>
        </li>
        <li className="flex items-start gap-1">
          <GuideBar />
          <span className="min-w-0 flex-1">NG例：ぶれている、人が映り込んでいる</span>
        </li>
      </ul>
    </section>
  );
};

const GuideBar = () => (
  <span
    aria-hidden
    className="mt-1.5 inline-block h-3 w-[3px] shrink-0 rounded-[1px] bg-primary"
  />
);
